/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros 
Descripcion:        Constantes para uso general
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
(@#)1-A   SOL 32929    Emanuel Guivar           01/08/2025   Cambios fase 2 - Seguros
(@#)2-A   SOL 33756    Emanuel Guivar           30/12/2025   Cambios fase 3 - Seguros desailiacion, siniestro y endosos
--------------------------------------------------------------------------------------------------------------
*/

export const MediosRespuesta: InputSelectData = [
    {id: 'Correo electronico', text: 'Correo electrónico'},
];


export const Messages = {
    DocumentosError: 'Error al obtener documentos, intente nuevamente en unos minutos.',
    SolicitudesError: 'Error al obtener solicitudes de seguro, intente nuevamente en unos minutos.',
    PrestamoError: 'Error al obtener los creditos, intente nuevamente en unos minutos.',
    SegurosError: 'Error al obtener los seguros, intente nuevamente en unos minutos.',
    CoberturasError: 'Error al obtener las coberturas del seguro, intente nuevamente en unos minutos.',
    RegistroError: 'Error de comunicación, intente nuevamente en unos minutos.',
    DepartamentoError: 'Error al obtener departamentos, intente nuevamente en unos minutos.',
    ProvinciaError: 'Error al obtener provincias, intente nuevamente en unos minutos.',
    DistritoError: 'Error al obtener distritos, intente nuevamente en unos minutos.',
    MediosError: 'Error al obtener medios de devolución, intente nuevamente en unos minutos.', //(@#)1-A
    RespuestaError: 'Error al obtener medios de respuesta, intente nuevamente en unos minutos.', //(@#)1-A
    //(@#)2-A inicio
    MotivosError: 'Error al obtener los motivos de desafiliacion, intente nuevamente en unos minutos.', 
    LocalesError: 'Error al obtener locales, intente nuevamente en unos minutos.',
    DireccionError: 'Error al obtener direccion, intente nuevamente en unos minutos.',
    PesoArchivoError: 'Error al obtener peso maximo de archivo, intente nuevamente en unos minutos.',
    //(@#)2-A fin
};